module.exports = __webpack_public_path__ + "static/kidneys-image-0cc3b34953307eb89836b29c070caa17.png";